// Shared Swiper config
export const SWIPER_CONFIG = {
    grabCursor: true,
};
